/* eslint-disable jsx-a11y/control-has-associated-label */
import { If } from 'aa_common/front-end/components'
import { getNs } from 'common/i18n-config'
import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import React from 'react'

import { CreditHeader, DebitHeader, Grid, GridItem, StyledTable, SummaryHeader, TableTitle } from './styles'

const { t, useNsReady } = getNs(['components/organisms/accounting/auto-journal-setting-tab'])
const JournalItemSettingTable: React.FC<{ title: string }> = ({ title, children }) => {
  useNsReady()
  const { isEnable } = useCheckFlag(FeatureFlagNames.RemarkInJournalSettings)

  return (
    <div className="journal-item-setting-table">
      <TableTitle>{title}</TableTitle>
      <If condition={!isEnable}>
        <StyledTable>
          <thead>
            <tr>
              <th className="header-level-0" colSpan={3}>
                {t('debit')}
              </th>
              <th className="header-level-0" colSpan={3}>
                {t('credit')}
              </th>
            </tr>
            <tr>
              <th className="section-name" />
              <td className="category-header">{t('account_item')}</td>
              <td className="category-header">{t('account_subitem')}</td>
              <th className="section-name" />
              <td className="category-header">{t('account_item')}</td>
              <td className="category-header">{t('account_subitem')}</td>
            </tr>
          </thead>
          {children}
        </StyledTable>
      </If>
      <If condition={!!isEnable}>
        <Grid>
          <DebitHeader className="grid-header">{t('debit')}</DebitHeader>
          <CreditHeader className="grid-header">{t('credit')}</CreditHeader>
          <SummaryHeader className="grid-header">{t('summary')}</SummaryHeader>

          <GridItem className="section-name" />
          <GridItem className="section-name account-item">{t('account_item')} </GridItem>
          <GridItem className="section-name">{t('account_subitem')}</GridItem>
          <GridItem className="section-name" />
          <GridItem className="section-name account-item">{t('account_item')} </GridItem>
          <GridItem className="section-name account-sub-item">{t('account_subitem')}</GridItem>
          {children}
        </Grid>
      </If>
    </div>
  )
}
export default JournalItemSettingTable
